/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A filter in the provider's native query syntax. It cannot be combined with fieldFilters.  It can apply to incremental reads, backfills or a search API call.
 * @export
 * @interface RawFilter
 */
export interface RawFilter {
    /**
     * The syntax of the filter. Supported values are documented in each provider's guide. For example, `soql` is a supported filter type for Salesforce.
     * @type {string}
     * @memberof RawFilter
     */
    type: string;
    /**
     * The filter expression.
     * @type {any}
     * @memberof RawFilter
     */
    filter: any | null;
}

/**
 * Check if a given object implements the RawFilter interface.
 */
export function instanceOfRawFilter(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "filter" in value;

    return isInstance;
}

export function RawFilterFromJSON(json: any): RawFilter {
    return RawFilterFromJSONTyped(json, false);
}

export function RawFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): RawFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'filter': json['filter'],
    };
}

export function RawFilterToJSON(value?: RawFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'filter': value.filter,
    };
}

